<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.fileSystem.path')}}</label>
            <div class="col">
                <input type="text" v-model="value.Path" class="form-control" required maxlength="300" />
            </div>
        </div>
        
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.SlugifyFileName" />
                    {{translate('targetSystem.fileSystem.slugifyFileName')}}
                    <small class="d-block text-muted">{{translate('targetSystem.fileSystem.slugifyFileNameSubtext')}}</small> 
                </label>         
            </div>
        </div>
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.PrependIdToFileName" />
                    {{translate('targetSystem.fileSystem.PrependIdToFileName')}}
                    <small class="d-block text-muted">{{translate('targetSystem.fileSystem.PrependIdToFileNameSubtext')}}</small>
                </label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label for="DropFilesUnderUniqueDirectory">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectory')}}:</label>
                <select name="DropFilesUnderUniqueDirectory" id="DropFilesUnderUniqueDirectory" class="form-control" v-model="value.DropFilesUnderUniqueDirectory">
                    <option value=""></option>
                    <option value="JobId">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.jobId')}}</option>
                    <option value="DocumentNo">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.documentNo')}}</option>
                    <option value="TrackingNo">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.trackingNo')}}</option>
                </select>
                 <small class="d-block text-muted">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectorySubtext')}}</small>
            </div>
           
        </div>        
    </div>
</template>

<script>

export default {
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {

    }
}

</script>
